import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Sidebar from "./Sidebar";
import axios from 'axios';
import { useEffect, useState } from "react";
export default function Client() {

    var url = `http://localhost:${process.env?.PORT || 3000}/`

    const [shops, setshops] = useState([]);
    function fetchShops() {
        axios.post(url + 'getShopsAdmin').then((succ) => {
            setshops(succ.data);
            console.log(succ.data);
        })
    }
    useEffect(() => {
        fetchShops();
    }, [])

    return (
        <>

            <Grid container height={'100vh'} className='admin-Section' width={'100%'}>
                <Sidebar />
                <Grid container justifyContent={'center'} height={'100%'} size={{ xs: 9.6 }} pr={3.3} pt={13}>
                    <TableContainer>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Owner Name</TableCell>
                                    <TableCell>Shop Name</TableCell>
                                    <TableCell>Address</TableCell>
                                    <TableCell>Phone no.</TableCell>
                                    <TableCell>Email</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {shops.map((row) => (
                                    <TableRow>
                                        <TableCell>{row.OName}</TableCell>
                                        <TableCell>{row.Name}</TableCell>
                                        <TableCell>{decodeURIComponent(row.Address)}</TableCell>
                                        <TableCell>{row.Phone}</TableCell>
                                        <TableCell>{row.Email}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

        </>
    )

}